import { IconCrossRounded } from 'modules/common/components/_icons/icons'
import { useTranslation } from 'modules/common/hooks/useTranslation'

export const FatcaRefusedAccountModalContent = () => {
  const { t } = useTranslation('common-components')

  return (
    <div className="flex flex-col items-center text-center text-info-600">
      <IconCrossRounded className="mb-6 h-16 w-16 text-danger" />
      <h2>{t('authenticatedGuard.fatcaRefusedModal.title')}</h2>
      <p className="mt-2 leading-6">
        {t('authenticatedGuard.fatcaRefusedModal.description')}
      </p>
    </div>
  )
}
